import React from "react";
import Cropme from 'croppie';
import OutsideClickHandler from "react-outside-click-handler";
import ImageComponent from "../../Common/ImageComponent";
import { CameraIconHoc, ClosePopupHoc, EditCameraHoc, RemoveHoc, ResetHoc, SampleGroupProfile, SampleProfile, TakephotoHoc, TickHoc, UploadHoc, ViewphotoHoc, loaderGIF } from "../../../assets/images";
import { useSelector } from "react-redux";
import { CAMERA_ERROR, CAMERA_PERMISSION_DENIED, CANCEL, CROP_PHOTO, PROFILE, REMOVE, REMOVE_PHOTO, REMOVE_YOUR_PROFILE_PHOTO, TAKE_PHOTO, UPLOAD_PHOTO, VIEW_PHOTO } from "../../../processENV";
import WebChatCroppie from "../CroppieImage/WebChatCroppie";
import WebChatCamera from "./WebChatCamera";
import { blockOfflineAction, dataURLtoFile, fileToBlob, isAppOnline } from "../../../Helpers/Utility";
import { toast } from "react-toastify";
import { NO_INTERNET, PROFILE_UPDATE_SUCCESS } from "../../../Helpers/Constants";
import SDK from "../../../SDK";
import { WebChatCropOption } from "../CroppieImage/WebChatCropOption";
import { formatGroupIdToJid, isLocalUser } from "../../../Helpers/Chat/User";
import IndexedDb from "../../../Helpers/IndexedDb";

const ContactInfoProfileUpdate = (props) => {
    let cropme;
    const localDb = React.useMemo(() => new IndexedDb(), []);
    const [ webChatVCardState , setWebChatVCardState] = React.useState({
        profileBlopData: "",
        profileImg: "",
        showImgDropDown: false,
        showProfileImg: false,
        profileCamera: false,
        showProfileCamera: false,
        photoTaken: false,
        camImage: "",
        camImageFile:"",
        cameraLoader: false,
        onCameraError: false,
        onCameraPermissionDenied: false,
        filename: "image",
        loaderIcon: false,
        cameraPopup: false,
        openCropy: false,
        showProfilePhotoRemove: false,
        imageURL: SampleGroupProfile,
        imageToken: props.imageToken
    })

    const {
        // profileBlopData,
        profileImg,
        showImgDropDown,
        showProfileImg,
        // profileCamera,
        showProfileCamera,
        photoTaken,
        camImage,
        camImageFile,
        // cameraLoader,
        onCameraError,
        onCameraPermissionDenied,
        // filename,
        loaderIcon,
        cameraPopup,
        // openCropy,
        showProfilePhotoRemove,
        // imageURL,
        // imageToken
    } = webChatVCardState

    const [cropState,setCropState] = React.useState('')

    const storeData = useSelector((state) => state);
    const { vCardData } = storeData

    let exitGroup = !props.participants.find(users => isLocalUser(users.userId));


    /**
     * handleProfileImg() method to perform fetch the image form url and encrypt the vcard data.
     *
     * @param {object} response
     */
    const handleProfileImg = (response) => {
        /**
        // if (val !== SampleProfile) {
        //     setWebChatVCardState({ ...webChatVCardState, profileImg: val });
        // }
        // else {
        //     setWebChatVCardState({ ...webChatVCardState, profileImg: SampleProfile, showProfileImg: false });
        //     // // store.dispatch(modalActiveClassAction(false));
        // }
        */
        let token = "";
		if (response.image || token) {
			localDb.getImageByKey(response.image, 'profileimages').then(blob => {
				// // const URL = window.URL || window.webkitURL;
				const blobUrl = window.URL.createObjectURL(blob);
				setWebChatVCardState({
					...webChatVCardState, profileImg: blobUrl });
			}).catch(err => {
				setWebChatVCardState({
					...webChatVCardState, profileImg: SampleGroupProfile });
			})
		} else {
			setWebChatVCardState({
				...webChatVCardState, profileImg: SampleGroupProfile, showProfileImg: false });
		}
    }

    /**
     * handleCropImageProfileUpdate() to load the loader for croppie.
     */
    const handleCropImage = () => {
        if (!isAppOnline()) {
            blockOfflineAction()
            return
        }
        // setWebChatVCardState({ ...webChatVCardState, loaderIcon: true })
        cropImage();
    }

    /**
     * cropImageProfileImg() to crop the selected image.
     */
    const cropImage = () => {
        cropState.result({
            type: "base64",
            size: "original"
        }).then(base64 => {
            const { filename = "" } = webChatVCardState
            const imageFile = dataURLtoFile(base64, filename);
            setWebChatVCardState({ ...webChatVCardState,
                loaderIcon: true
            })
            handleSaveImage(imageFile)
        })    
    }

    /**
     * handleSaveImage() to save the selected image.
     */
    const handleSaveImage = async (image) => {
        try {
            const groupImage = image;
            const response = await SDK.setGroupProfile(formatGroupIdToJid(props.jid), props.groupName, groupImage);
            if (response.statusCode !== 200) {
                let message = response.message;
                // To get the internet offline status,
                // execute the toast in setTimeout
                setTimeout(() => {
                    if (!navigator.onLine) message = NO_INTERNET;
                    message && toast.error(message);
                }, 150);
            }
            if (response.statusCode === 200) {
                const fileBlob = await fileToBlob(image);
                // // let fileToken = "";
                // // if(response.fileTokenThumb !== "") fileToken = response.fileTokenThumb;
                // // else fileToken = response.fileToken;
                // // indexedDb.setImage(fileToken, fileBlob, "profileimages");
                setWebChatVCardState({ ...webChatVCardState, profileImg: URL.createObjectURL(fileBlob) });
                toast.success(PROFILE_UPDATE_SUCCESS);
            }

            handleProfileCameraPopupClose();
        } catch (error) {
            toast.error(error.message);
            handleProfileCameraPopupClose();
        }
    }

    /**
     * updateProfileImage() to get image file from child component.
     */

    const updateProfileImage = (file) => {
        if (cropme) {
            cropme.destroy();
        }
        if (file) {
            setWebChatVCardState({
                ...webChatVCardState,
                filename: file.name,
                camImage: file,
                cameraPopup: true
            })
        }
    }

    /**
     * handleVCardClose() method to maintain state for view profile popup close window state.
     */
    /**
    const handleVCardClose = () => {
        setWebChatVCardState({ ...webChatVCardState,
            viewEmojiUsername: false,
            viewEmojiStatus: false,
            viewEdit: true,
            viewEditStatus: true,
            viewTick: true,
            viewTickStatus: true,
            charCount: false,
            charCountStatus: false,
            showImgDropDown: false,
            showProfilePhotoRemove: false
        });
    }
    */

    /**
     * removeProfileImage() method to maintain state to profile picture.
     */
    const removeProfileImage = async (e) => {
        if (blockOfflineAction()) return;
        let response = await SDK.setGroupProfile(formatGroupIdToJid(props.jid), props.groupName, "");
        if (response.statusCode === 200) {
            setWebChatVCardState({ ...webChatVCardState,
                imageToken: "",
                showImgDropDown: false,
                showProfilePhotoRemove: false
            });
            toast.success('Profile picture removed successfully');
        } else {
            const { message = "" } = response;
            toast.error(message);
        }
    }

    /**
     * setWebcamImageVcard() method to maintain state to set a image taken from webcamera.
     */
    const setWebcamImageVcard = (webcamImageVcard = {}) => {
        if (webcamImageVcard.size > 0) {
            let file = new FileReader();
            file.readAsDataURL(webcamImageVcard);
            file.onload = () => {
                // // let fileImage = file.result;
                setWebChatVCardState({
                    ...webChatVCardState,
                    photoTaken: true, camImageFile: webcamImageVcard, 
                    camImage: webcamImageVcard, openCropy: true
                })
                // updateProfileImage(webcamImageVcard)
            }
        } else {
            setWebChatVCardState({
                ...webChatVCardState, showProfileCamera: true })
        }
    }

    React.useEffect(()=>{
        if(cameraPopup === true) addFromFile(camImage);
    },[cameraPopup,camImage])
    
    React.useEffect(()=>{
        if(photoTaken === true) addFromCamera(camImageFile);
    },[photoTaken])

    React.useEffect(()=>{
		if(vCardData) {
            /**
			// setWebChatVCardState({
			// 	...webChatVCardState,
            //     vCardDatas: vCardData
            // });
            */
            handleProfileImg(vCardData);
		}
	},[vCardData])

    React.useEffect(()=>{
		if(vCardData) {
            /**
			// setWebChatVCardState({
			// 	...webChatVCardState,
            //     vCardDatas: vCardData
            // });
            */
            handleProfileImg(vCardData);
		}
	},[])

    const addFromFile = (file) => {
        const element = document.getElementById("fileContainer")
        element.innerHTML = "";
        element.classList.remove("croppie-container")
        cropme = new Cropme(element, WebChatCropOption);
        let reader = new FileReader();
        reader.onload = function (e) {
            cropme.bind({
                url: e.target.result
            }).then(() => {
                Object.assign(document.querySelector('.cr-viewport').style, {
                    width
                        : '200px', height: '200px'
                })
                cropme.setZoom(0)

            })
        };
        reader.readAsDataURL(file);
        setCropState(cropme);
    }

    const addFromCamera = (file) => {
        const element = document.getElementById("CameraContainer")
        cropme = new Cropme(element, WebChatCropOption);
        let reader = new FileReader();
        reader.onload = function (e) {
            cropme.bind({
                url: e.target.result
            }).then(() => {
                Object.assign(document.querySelector('.cr-viewport').style, {
                    width
                        : '200px', height: '200px'
                })
                cropme.setZoom(0)
            })
        };
        reader.readAsDataURL(file);
        setCropState(cropme);
    }

    /**
     * onCameraCheck() method to find whether camera device is there.
     */
    const onCameraCheck = (errorProfile = {}) => {
        const { name = "" } = errorProfile;
        if (name === "NotAllowedError") {
            setWebChatVCardState({ ...webChatVCardState, onCameraPermissionDenied: true });
        } else if (name === "NotFoundError") {
            setWebChatVCardState({ ...webChatVCardState, onCameraError: true })
        }
    }

    /**
     * handleProfileImgDropDown() method to maintain state to show dropdown in profile page.
     */
    const handleProfileImgDropDownVcard = (e) => {
        // // if (showImgDropDown === false) {
            setWebChatVCardState({ ...webChatVCardState, showImgDropDown: !showImgDropDown, openCropy: true })
            // // store.dispatch(modalActiveClassAction(true));
        // }
        // else {
        //     setWebChatVCardState({ ...webChatVCardState, showImgDropDown: false });
        //     // // store.dispatch(modalActiveClassAction(false));
        // }
    }

    /**
     * handleProfileImageShow() method to maintain state to show profile image in big screen.
     */
    const handleProfileImageShow = (e) => {
        setWebChatVCardState({ ...webChatVCardState, showProfileImg: true, showImgDropDown: false, openCropy: false });
        // // store.dispatch(modalActiveClassAction(true));

        //to show the original Image in big screen instead of thumbImage
        // const { groupImage = "" } = props.roster;
        // indexedDb
        // .getImageByKey(groupImage, "profileimages", "")
        // .then((blob) => {
        //     const blobUrl = window.URL.createObjectURL(blob);
        //     setWebChatVCardState({ ...webChatVCardState, profileImg: blobUrl });
        // })
        // .catch(() => {
        //     setWebChatVCardState({ ...webChatVCardState, profileImg: "" });
        // });
    
    }

    const getImageUrl = (url) => {
        setWebChatVCardState({ ...webChatVCardState, profileImg: url });
    }

    /**
     * handleProfileImgClose() method to maintain state to close profile image.
     */
    const handleProfileImgClose = (e) => {
        setWebChatVCardState({ ...webChatVCardState, showProfileImg: false });
        // // store.dispatch(modalActiveClassAction(false));
    }

    /**
     * handleProfileCameraShow() method to open camera popup.
     */
    const handleProfileCameraShow = (e, processType) => {
        // // if (processType !== 'reset' && blockOfflineAction()) return;
        setWebChatVCardState({ ...webChatVCardState, showProfileCamera: true, showImgDropDown: false,openCropy: false, photoTaken: false, cameraLoader: true });
    }

    /**
     * handleProfilePhotoRemoveShow() method to open profile photo remove prompt.
     */
    const handleProfilePhotoRemoveShow = (e) => {
        // // if (blockOfflineAction()) return;
        setWebChatVCardState({ ...webChatVCardState, showProfilePhotoRemove: true, showImgDropDown: false, openCropy: false });
    }

    /**
     * handleProfileRemovephotoClose() method to close profile photo remove prompt.
     */
    const handleProfileRemovephotoClose = (e) => {
        setWebChatVCardState({ ...webChatVCardState, showProfilePhotoRemove: false });
    }

    /**
     * handleProfileCameraClose() method to close profile camera popup.
     */
    const handleProfileCameraClose = (e) => {
        handleProfileCameraPopupClose();
    }

    /**
     * handleProfileCameraPopupClose() method to close profile camera popup.
     */
    const handleProfileCameraPopupClose = () => {
        setWebChatVCardState({ ...webChatVCardState,
            showProfileCamera: false,
            photoTaken: false,
            onCameraError: false,
            onCameraPermissionDenied: false,
            loaderIcon: false,
            cameraPopup: false,
            showImgDropDown: false,
            openCropy: false
        });
    }

return (
    <React.Fragment>
        <div className="userprofile-popup">
            <div className="profile-image">
                <OutsideClickHandler
                    onOutsideClick={() => {
                        /**
                        // Store.dispatch(modalActiveClassAction(false));
                        // this.setState({ showImgDropDown: false });
                        */
                    }}>
                    {/* user image empty no perview button */}
                    <ImageComponent
                        chatType={props.chatType}
                        // // blocked={blocked}
                        // // temporary={temporary}
                        imageToken={props.imageToken}
                        getImageUrl={getImageUrl}
                        onclickHandler={(e) => profileImg !== SampleGroupProfile ? handleProfileImageShow(e) : null}
                    />
                    <i className="camera-edit" onClick={(e) => handleProfileImgDropDownVcard(e)}>
                        {!exitGroup && <EditCameraHoc viewBox="0 0 35.141 35.188"/>}
                    </i>
                     {showImgDropDown &&
                        <ul className="profile-dropdown">
                            {profileImg && <>
                                {profileImg !== SampleGroupProfile &&
                                    <li
                                        title={VIEW_PHOTO}
                                        onClick={(e) => handleProfileImageShow(e)}
                                    >
                                        <i className="profileedit-options">
                                            <ViewphotoHoc />
                                        </i><span>{VIEW_PHOTO}</span></li>
                                }
                                <li title={TAKE_PHOTO}
                                    onClick={(e) => handleProfileCameraShow(e)}>
                                    <i className="profileedit-options">
                                        <TakephotoHoc viewBox="0 0 14.8 12.8"/>
                                    </i>
                                    <span>{TAKE_PHOTO}</span>
                                </li>
                                {profileImg !== SampleGroupProfile &&
                                    <li title={REMOVE_PHOTO}
                                        onClick={(e) => handleProfilePhotoRemoveShow(e)}>
                                        <i className="profileedit-options">
                                            <RemoveHoc viewBox="0 0 14 14"/>
                                        </i>
                                        <span>{REMOVE_PHOTO}</span>
                                    </li>
                                }
                                <li className="upload_photo" title={UPLOAD_PHOTO}>
                                    <label className="UploadLabel" htmlFor="ProfileUpload"></label>
                                    <i className="profileedit-options"><UploadHoc viewBox="0 0 14 14"/></i>
                                    <span className="uploadphoto">
                                        <span>{UPLOAD_PHOTO}</span>
                                        <WebChatCroppie
                                            type={PROFILE}
                                            loader={loaderIcon}
                                            cameraPopup={cameraPopup}
                                            cropImage={cropImage}
                                            updateProfileImage={updateProfileImage}
                                            closePopUp={handleProfileCameraPopupClose}
                                        />
                                    </span>
                                </li>
                            </>}
                            {!profileImg &&
                                <>
                                    <li title={UPLOAD_PHOTO}>
                                        <i className="profileedit-options"><UploadHoc viewBox="0 0 14 14"/></i>
                                        <span className="uploadphoto">
                                            <span>{UPLOAD_PHOTO}</span>
                                            <WebChatCroppie
                                                type={PROFILE}
                                                loader={loaderIcon}
                                                cameraPopup={cameraPopup}
                                                cropImage={cropImage}
                                                updateProfileImage={updateProfileImage}
                                                closePopUp={handleProfileCameraPopupClose}
                                            />
                                        </span>
                                    </li>
                                    <li
                                        title={TAKE_PHOTO}
                                        onClick={(e) => handleProfileCameraShow(e)}>
                                        <i className="profileedit-options"><TakephotoHoc viewBox="0 0 14.8 12.8"/></i>
                                        <span>{TAKE_PHOTO}</span>
                                    </li>
                                </>
                            }
                        </ul>
                    }
                    {showProfileImg &&
                        <div className="Viewphoto-container">
                            <div className="Viewphoto-preview">
                                <img src={profileImg} alt="vcard-profile" />
                                <i className="preview-close"
                                    onClick={(e) => handleProfileImgClose(e)}>
                                    <ClosePopupHoc viewBox="0 0 24 24"/>
                                </i>
                            </div>
                        </div>
                    }
                    {showProfileCamera &&
                        <div className="camera-container">
                            {onCameraError &&
                                <div className="camera-popup">
                                    <h4>{CAMERA_NOT_FOUND}</h4>
                                    <i>
                                        <CameraIconHoc viewBox="0 0 79 52.5"/>
                                    </i>
                                    <p>{CAMERA_ERROR}</p>
                                    <div className="popup-controls">
                                        <button
                                            type="button"
                                            name="btn-cancel"
                                            className="btn-okay"
                                            onClick={(e) => handleProfileCameraClose(e)}
                                        >
                                            {"Okay"}
                                        </button>
                                    </div>
                                </div>}

                            {onCameraPermissionDenied &&
                                <div className="camera-popup">
                                    <h4>{PERMISSION_DENIED}</h4>
                                    <i>
                                        <CameraIconHoc viewBox="0 0 79 52.5"/>
                                    </i>
                                    <p>{CAMERA_PERMISSION_DENIED}</p>
                                    <div className="popup-controls">
                                        <button type="button"
                                            className="btn-okay"
                                            name="btn-cancel">{"Okay"}
                                            onClick={(e) => handleProfileCameraClose(e)}
                                        </button>
                                    </div>
                                </div>}

                            {!onCameraError && !onCameraPermissionDenied &&
                                <div className="camera-popup-visible">
                                    <div className="userprofile-header">
                                        <i
                                            onClick={(e) => handleProfileCameraClose(e)}>
                                            <ClosePopupHoc viewBox="0 0 24 24"/></i>
                                        {photoTaken ? <h5>{CROP_PHOTO}</h5> : <h5>{TAKE_PHOTO}</h5>}
                                    </div>
                                    <div className="cameraview">
                                        {photoTaken &&
                                            <div id='CameraContainer'></div>
                                        }
                                        {!photoTaken &&
                                            <WebChatCamera
                                                sendFile={setWebcamImageVcard}
                                                onCameraCheck={onCameraCheck}
                                            />
                                        }
                                    </div>
                                    {photoTaken &&
                                        <div className="popup-controls">
                                            {!loaderIcon &&
                                                < i title="Re capture">
                                                    <ResetHoc viewBox="0 0 39 39"
                                                        onClick={(e) => handleProfileCameraShow(e, 'reset')} />
                                                </i>}
                                            {!loaderIcon ?
                                                <i title="Update Profile"
                                                    onClick={(e) => handleCropImage()}>
                                                    <TickHoc viewBox="0 0 39 39"/>
                                                </i> : <img src={loaderGIF} alt="loader" />
                                            }
                                        </div>
                                    }
                                </div>}
                        </div>
                    }
                    {showProfilePhotoRemove &&
                        <div className="removephoto-container">
                            <div className="removephoto-popup">
                                <div className="removephoto-label">
                                    <label>{REMOVE_YOUR_PROFILE_PHOTO}</label>
                                </div>
                                <div className="removephoto-noteinfo">
                                    <button
                                        type="button"
                                        className="btn-cancel"
                                        onClick={(e) => handleProfileRemovephotoClose(e)}
                                        name="btn-cancel"
                                    >
                                        {CANCEL}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn-removephoto"
                                        onClick={(e) => removeProfileImage(e)}
                                        name="btn-remove"
                                    >
                                        {REMOVE}
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </OutsideClickHandler >
            </div>
        </div>
    </React.Fragment>
)};

export default ContactInfoProfileUpdate;
